import { all, takeLeading, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR, SUCCESS } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';
import { saveToLocalStorage } from '../../utils/util';

import { requestSocialLogin } from './social-login.actions';
import { requestViewPersonProfile } from '../party/party.actions';
import { getSocialLoginRequest } from './social-login.endpoints';
import { requestCreateInitialSocialPerson } from '../registration/registration.actions';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';

export function* performSocialLoginRequest({ payload }) {
  const { input, onSuccess, navigate } = payload;

  try {
    yield put(addSpinner('Logging In'));

    const [endpoint, options] = getSocialLoginRequest(input);
    const { data } = yield call(axios, endpoint, options);
    const { token, user, registrationStatus, keyUUID } = data;

    if (!user?.personExternalReference) {
      const initialPerson = {
        email: user.email,
      };

      yield call(saveToLocalStorage, 'token', token);
      yield put(requestCreateInitialSocialPerson({ initialPerson, navigate }));
    } else {
      if (registrationStatus === 'Registration Incomplete' || registrationStatus === 'Pending Email Verification') {
        yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
        yield put(removeSpinner('Logging In'));

        if (keyUUID) {
          yield call(navigate, `/registration/${user?.personExternalReference}?keyExternalReference=${keyUUID}`);
        } else {
          yield call(navigate, `/registration/${user?.personExternalReference}`);
        }
        return;
      } else if (registrationStatus === 'Pending Email Verification') {
        const message = 'Please check your emails, and verify your email address.';
        yield put(removeSpinner('Logging In'));
        yield put(addSystemNotice({ type: ERROR, message }));
        yield call(navigate, '/');
      }

      yield call(saveToLocalStorage, 'token', token);
      yield call(saveToLocalStorage, 'personExternalReference', user.personExternalReference);

      yield put(requestViewPersonProfile({ personExternalReference: user.personExternalReference }));

      if (onSuccess) {
        yield call(onSuccess);
      }

      yield put(removeSpinner('Logging In'));
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Logging In'));
    yield put(addSystemNotice({ type: ERROR, message }));
    yield call(navigate, '/');
  } finally {
    yield put(removeSpinner('Logging In'));
  }
}

export function* watchForSocialLoginRequest() {
  yield takeLeading(requestSocialLogin.type, performSocialLoginRequest);
}

export default function* socialLoginSaga() {
  yield all([watchForSocialLoginRequest()]);
}
